import Base from 'app/models/base';
import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('customs_items'),
});



// WEBPACK FOOTER //
// ./app/models/customs_item.js